class SubscriptionProductType {
	
	/**
	 * Product types.
	 */
	static SUBSCRIPTION = 'subscription';

	/**
	 * Regular product type.
	 */
	static REGULAR = 'regular';

	/**
	 * Get all product types.
	 *
	 * @return {string[]}
	 */
	static getAll() {
		return [this.SUBSCRIPTION, this.REGULAR];
	}
}
export default SubscriptionProductType;